export default __webpack_public_path__ + "static/media/grafema_pilates_01.205bec42.jpg";